import { db } from "@/firebaseConfig";

const cashDrawersCollection = db.collection("cash_drawers");

const saveCashDrawer = async data => {
  cashDrawersCollection
    .doc()
    .set(data)
    .then(() => {
      console.log("CashDrawer successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateCashDrawer = async (id, data) => {
  cashDrawersCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("CashDrawer successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteCashDrawer = async id => {
  cashDrawersCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("CashDrawer successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getCashDrawerById = async id => {
  return cashDrawersCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  cashDrawersCollection,
  saveCashDrawer,
  updateCashDrawer,
  deleteCashDrawer,
  getCashDrawerById
};
